module.exports = __webpack_public_path__ + "static/media/Dip tray.b7fb19d3.svg";